import React, { useState, useEffect } from 'react';
import AxiosClient from '../../assets/AxiosClient';
import { useNavigate, useParams } from 'react-router-dom';
import { useStateContext } from '../../Contexts/ContextProvider';
import Loader from '../../assets/tools/Loder/loader';

const SectionSort = () => {
  const [sections, setSections] = useState([]);
  const [loading, setIsloading ] = useState (true) ; 

  const navigate = useNavigate();
  const { API } = useStateContext();
    const {id , lang } = useParams () ; 
  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await AxiosClient.get(`/conferences/${id}/sections/${lang}`);
        setSections(response.data);
      } catch (error) {
        console.error('Error fetching sections:', error);
      }finally {
        setIsloading(false) ;
    }
    };

    fetchSections();
  }, []);

  const moveSectionUp = (index) => {
    if (index > 0) {
      const newSections = [...sections];
      [newSections[index - 1], newSections[index]] = [
        newSections[index],
        newSections[index - 1],
      ];
      setSections(newSections);
    }
  };

  const moveSectionDown = (index) => {
    if (index < sections.length - 1) {
      const newSections = [...sections];
      [newSections[index], newSections[index + 1]] = [
        newSections[index + 1],
        newSections[index],
      ];
      setSections(newSections);
    }
  };

  const saveRanks = async () => {
    try {
      // Prepare the payload
      setIsloading(true) ; 
      const updatedSections = sections.map((section, index) => ({
        id: section.id,
        rank: index + 1,
      }));

      // Send the update request
      await AxiosClient.post('/sections/update_rank', { sections: updatedSections });

      console.log('Ranks updated successfully!');
      navigate(-1);
    } catch (error) {
      console.error('Error updating ranks:', error);
    } 
  };
  if (loading ) {
    return <Loader label="Loading section order..." />;
  }

  return (
    <div className="table-responsive p-4">
      <h2 className="title">Section List</h2>
      <table className="table table-striped">
        <thead className="text-primary">
          <tr>
            <th className="text-center">Title</th>
            <th className="text-center">Description</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {sections.map((section, index) => (
            <tr
              key={section.id}
              className={`text-center ${
                index % 2 === 0 ? 'bg-gray-50' : 'bg-white'
              } transition-bg duration-1000`}
            >
              <td>{section.title}</td>
              <td>{section.description}</td>
              <td>
                <button
                  className="btn btn-info btn-sm m-2"
                  onClick={() => moveSectionUp(index)}
                >
                  Move Up
                </button>
                <button
                  className="btn btn-danger btn-sm m-2"
                  onClick={() => moveSectionDown(index)}
                >
                  Move Down
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button className="btn btn-success m-2" onClick={saveRanks}>
        Save Ranks
      </button>
      <button className="btn btn-dark m-2" onClick={() => navigate(-1)}>
        Cancel
      </button>
    </div>
  );
};

export default SectionSort;
